import { render, staticRenderFns } from "./DfmProductsGrid.vue?vue&type=template&id=1285af5f"
import script from "./DfmProductsGrid.vue?vue&type=script&lang=js"
export * from "./DfmProductsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkedIconCard: require('/vercel/path0/components/LinkedIconCard.vue').default})
